export default __webpack_public_path__ + "static/media/footer.3c228fe8.png";